var _mask, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 33,
    viewBox: "0 0 53 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1029_229",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8936 32.5H2.9828C1.5309 32.5 0.358032 31.327 0.358032 29.8752H52.5742C52.5738 31.2714 51.3452 32.5 49.8933 32.5H49.8936Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8936 32.5H2.9828C1.5309 32.5 0.358032 31.327 0.358032 29.8752H52.5742C52.5738 31.2714 51.3452 32.5 49.8933 32.5H49.8936Z",
    fill: "#919699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.358032 29.8752V28.5419H-0.975301V29.8752H0.358032ZM52.5742 29.8752L53.9075 29.8756L53.9079 28.5419H52.5742V29.8752ZM49.8936 31.1667H2.9828V33.8333H49.8936V31.1667ZM2.9828 31.1667C2.26731 31.1667 1.69137 30.5907 1.69137 29.8752H-0.975301C-0.975301 32.0634 0.794488 33.8333 2.9828 33.8333V31.1667ZM0.358032 31.2086H52.5742V28.5419H0.358032V31.2086ZM51.2408 29.8749C51.2407 30.517 50.6268 31.1667 49.8933 31.1667V33.8333C52.0635 33.8333 53.9069 32.0258 53.9075 29.8756L51.2408 29.8749ZM49.8933 33.8333H49.8936V31.1667H49.8933V33.8333Z",
    fill: "#919699",
    mask: "url(#path-1-inside-1_1029_229)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4974 28.4232H4.37897C4.15576 28.4232 3.93215 28.2557 3.93215 27.9764L3.93176 2.62227C3.93176 1.44933 4.88109 0.5 6.05403 0.5H46.8217C47.9946 0.5 48.944 1.44933 48.944 2.62227V28.0323C48.944 28.2555 48.7206 28.4232 48.4974 28.4232Z",
    stroke: "#919699",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLaptop);
export default __webpack_public_path__ + "static/media/icon-laptop.78cb9cd21348c064ad5c3e187fabf434.svg";
export { ForwardRef as ReactComponent };